angular.module('app').directive('uiSort', [
    '$cookies',
    function($cookies) {
        return function(scope, element, attrs) {
            scope.$on('uiSortColumn', function(e, data) {
                if (attrs.uiSort === data.sortColumn) {
                    element.removeClass('st-sort-descent st-sort-ascent');
                    element.attr('data-sort', data.sortType);
                    element.addClass(
                        data.sortType === 'desc'
                            ? 'st-sort-descent'
                            : 'st-sort-ascent'
                    );
                    element.addClass('sort-active');
                } else {
                    element.removeClass('sort-active');
                }
            });

            function sort(initial) {
                $('[ui-sort]').removeClass('st-sort-descent st-sort-ascent');

                var dataSort = element.attr('data-sort');
                dataSort =
                    dataSort === 'undefined'
                        ? 'desc'
                        : dataSort === 'desc'
                        ? 'asc'
                        : 'desc';

                if (initial && scope.app.sort.type) {
                    dataSort = scope.app.sort.type;
                }

                if (!initial) {
                    element.addClass(
                        dataSort === 'desc'
                            ? 'st-sort-descent'
                            : 'st-sort-ascent'
                    );

                    var expiration = new Date();
                    expiration.setDate(expiration.getDate() + 365);

                    // save to cookies
                    $cookies.put('sortColumn', attrs.uiSort, {
                        expires: expiration,
                    });
                    $cookies.put('sortType', dataSort, { expires: expiration });
                }
                element.attr('data-sort', dataSort);

                scope.$root.$broadcast('uiSortColumn', {
                    sortColumn: attrs.uiSort,
                    sortType: dataSort,
                });

                return;
            }

            if (attrs.uiSort == scope.app.sort.column) {
                sort(true);
            }

            element.bind('click', function() {
                sort(false);
            });
        };
    },
]);
